export const proxySvgUrl = (url: string): string =>
  `/api/svg?url=${encodeURIComponent(url)}`
